import { useState, useEffect } from 'react';

const tools = [
  { name: 'Gist Images', description: 'AI-powered alt text generation' },
  { name: 'Gist Speech', description: 'High-quality text-to-speech' },
  { name: 'Gist Blog', description: 'Blog meta generation' },
];

export default function RotatingToolText() {
  const [currentTool, setCurrentTool] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTool((prev) => (prev + 1) % tools.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <span className="gradient-text">
      {tools[currentTool].name}
    </span>
  );
}

